(function () {
  function visibleText(el) {
    return (el.textContent || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hasMedia(el) {
    return !!el.querySelector('img, iframe, video, svg, table, form, input, button, picture, audio');
  }

  function isSpacerElement(el) {
    if (!el || el.nodeType !== 1) return false;
    const tag = el.tagName;
    if (!/^(P|DIV|SPAN|SECTION|ARTICLE|H1|H2|H3|H4|H5|H6|CENTER)$/.test(tag)) return false;
    if (visibleText(el).length > 0) return false;
    if (hasMedia(el)) return false;
    // Empty / whitespace-only nodes, or wrappers that only hold hr/br
    return true;
  }

  function collapseDoubleBreaks(root) {
    root.querySelectorAll('br').forEach((br) => {
      let node = br.nextSibling;
      while (node && node.nodeType === 3 && !node.textContent.replace(/\u00a0/g, ' ').trim()) {
        const empty = node;
        node = node.nextSibling;
        empty.remove();
      }
      if (node && node.nodeType === 1 && node.tagName === 'BR') {
        node.remove();
      }
    });
  }

  function removeDuplicateLeadingTitle(content) {
    const footer = content.closest('[data-clean-collection-seo-footer]');
    const titleEl = footer && footer.querySelector('.collection-seo-footer__title');
    if (!titleEl) return;

    const title = visibleText(titleEl).toLowerCase();
    if (!title) return;

    const kids = Array.from(content.children);
    for (let i = 0; i < kids.length; i++) {
      const el = kids[i];
      const text = visibleText(el);
      if (!text) continue;

      // Description often repeats the collection name as first h1/h2/bold paragraph
      if (text.toLowerCase() === title) {
        el.remove();
      }
      break;
    }
  }

  function normalizeSeoContent(root) {
    (root || document)
      .querySelectorAll('[data-clean-collection-seo-content], .collection-seo-footer__content')
      .forEach((content) => {
        // Word/MSO horizontal rules are the main source of huge gaps
        content.querySelectorAll('hr').forEach((hr) => hr.remove());

        // Strip Word "section break" wrappers that only held an hr (now empty)
        let removed = true;
        let guard = 0;
        while (removed && guard < 30) {
          removed = false;
          guard += 1;
          content.querySelectorAll('p, div, span, center, section, article, h1, h2, h3, h4, h5, h6').forEach((el) => {
            if (!content.contains(el)) return;
            if (isSpacerElement(el)) {
              el.remove();
              removed = true;
            }
          });
        }

        collapseDoubleBreaks(content);
        removeDuplicateLeadingTitle(content);

        // Neutralize Word inline spacing that fights theme CSS
        content.querySelectorAll('[style]').forEach((el) => {
          el.style.removeProperty('margin');
          el.style.removeProperty('margin-top');
          el.style.removeProperty('margin-bottom');
          el.style.removeProperty('margin-left');
          el.style.removeProperty('margin-right');
          el.style.removeProperty('padding');
          el.style.removeProperty('padding-top');
          el.style.removeProperty('padding-bottom');
          el.style.removeProperty('line-height');
          el.style.removeProperty('mso-line-height-rule');
        });

        content.dataset.seoNormalized = 'true';
      });
  }

  function bindToggle(toggle) {
    if (toggle.dataset.cleanSeoBound === 'true') return;
    toggle.dataset.cleanSeoBound = 'true';

    toggle.addEventListener('click', () => {
      const footer = toggle.closest('[data-clean-collection-seo-footer]');
      const expandable = footer?.querySelector('[data-clean-collection-seo-expandable]');
      const toggleText = toggle.querySelector('[data-clean-collection-seo-toggle-text]');
      if (!expandable) return;

      const expanded = expandable.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));

      if (toggleText) {
        toggleText.textContent = expanded
          ? toggle.dataset.cleanLessText || 'Read less'
          : toggle.dataset.cleanMoreText || 'Read more';
      }
    });
  }

  function init(root) {
    normalizeSeoContent(root);
    (root || document).querySelectorAll('[data-clean-collection-seo-toggle]').forEach(bindToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
